import { IconButton, styled } from '@mui/material'

const StyledSpinButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  height: '18px',
  width: '18px',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}))

export default StyledSpinButton
